"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralUtils = void 0;
const technical_indicator_enum_1 = require("../../@types/incoming/enum/technical-indicator.enum");
const specific_investor_mm_enum_1 = require("../../@types/outcoming/enum/specific-investor-mm.enum");
const news_sentiment_enum_1 = require("../../@types/outcoming/enum/news-sentiment.enum");
const price_avaliation_enum_1 = require("../../@types/outcoming/enum/price-avaliation.enum");
class GeneralUtils {
    static isEven(value) {
        return value % 2 === 0;
    }
    static getGeneralOverview(indications, config) {
        var _a, _b, _c, _d, _e, _f;
        const specificMM = (indications === null || indications === void 0 ? void 0 : indications.movingAverage) !== 'error'
            ? (_b = (_a = indications === null || indications === void 0 ? void 0 : indications.movingAverage) === null || _a === void 0 ? void 0 : _a.specificInvestorType) === null || _b === void 0 ? void 0 : _b.value
            : undefined;
        const newsSentiment = (indications === null || indications === void 0 ? void 0 : indications.extra) !== 'empty'
            ? (_d = (_c = indications === null || indications === void 0 ? void 0 : indications.extra) === null || _c === void 0 ? void 0 : _c.news) === null || _d === void 0 ? void 0 : _d.sentiment
            : undefined;
        const priceAvaliation = (indications === null || indications === void 0 ? void 0 : indications.extra) !== 'empty'
            ? (_f = (_e = indications === null || indications === void 0 ? void 0 : indications.extra) === null || _e === void 0 ? void 0 : _e.averagePrice) === null || _f === void 0 ? void 0 : _f.avaliation
            : undefined;
        const extraSummary = config.extra
            ? this.getExtraSummaryPoints(specificMM, newsSentiment, priceAvaliation)
            : this.getDefaultCategoryPoints();
        const techSummary = config.technical
            ? this.getTechSummaryPoints(indications.technical)
            : this.getDefaultCategoryPoints();
        const funSummary = config.fundamental
            ? this.getFundamentalSummaryPoints(indications.fundamental)
            : this.getDefaultCategoryPoints();
        const healthSummary = config.health
            ? this.getHealthSummaryPoints(indications.health)
            : this.getDefaultCategoryPoints();
        const allSummaries = this.getSummariesPerCategory(techSummary, funSummary, extraSummary, healthSummary);
        let qntBuyGeneral = 0;
        let qntSellGeneral = 0;
        allSummaries.forEach((summary) => {
            if (summary.qntBuy === -1) {
                return;
            }
            qntBuyGeneral += summary.qntBuy;
            qntSellGeneral += summary.qntSell;
        });
        return {
            generalSummary: {
                qntBuy: qntBuyGeneral,
                qntSell: qntSellGeneral,
            },
            byCategory: allSummaries,
        };
    }
    static getDefaultCategoryPoints() {
        return {
            qntBuy: -1,
            qntSell: -1,
        };
    }
    static getTechSummaryPoints(techIndications) {
        if (techIndications !== 'error' && techIndications) {
            return {
                qntBuy: techIndications.summary.qntBuy,
                qntSell: techIndications.summary.qntSell,
            };
        }
        return this.emptySummaryPoints();
    }
    static getFundamentalSummaryPoints(funIndications) {
        if (funIndications &&
            funIndications !== 'error' &&
            funIndications !== 'empty') {
            return {
                qntBuy: funIndications.summary.qntBuy,
                qntSell: funIndications.summary.qntSell,
            };
        }
        return this.emptySummaryPoints();
    }
    static getHealthSummaryPoints(healthIndications) {
        if (healthIndications &&
            healthIndications !== 'error' &&
            healthIndications !== 'empty') {
            return {
                qntBuy: healthIndications.summary.qntBuy,
                qntSell: healthIndications.summary.qntSell,
            };
        }
        return this.emptySummaryPoints();
    }
    static getExtraSummaryPoints(specificMM, newsSentiment, priceAvaliation) {
        let qntBuy = 0;
        let qntSell = 0;
        switch (specificMM) {
            case specific_investor_mm_enum_1.eSpecificInvestorMMInd.BUY:
                qntBuy++;
                break;
            case specific_investor_mm_enum_1.eSpecificInvestorMMInd.SELL:
                qntSell++;
                break;
        }
        switch (newsSentiment) {
            case news_sentiment_enum_1.eNewsSentiment.BUY:
                qntBuy += 2;
                break;
            case news_sentiment_enum_1.eNewsSentiment.SELL:
                qntSell += 2;
                break;
        }
        switch (priceAvaliation) {
            case price_avaliation_enum_1.ePriceAvaliation.GOOD:
            case price_avaliation_enum_1.ePriceAvaliation.VERY_GOOD:
                qntBuy++;
                break;
            case price_avaliation_enum_1.ePriceAvaliation.BAD:
            case price_avaliation_enum_1.ePriceAvaliation.HORRIBLE:
                qntSell++;
                break;
        }
        return {
            qntBuy,
            qntSell,
        };
    }
    static getSummariesPerCategory(techSummary, funSummary, extraSummary, healthSummary) {
        return [
            {
                name: 'Avaliações importantes',
                qntBuy: extraSummary.qntBuy,
                qntSell: extraSummary.qntSell,
            },
            {
                name: 'Saúde do ativo',
                qntBuy: healthSummary.qntBuy,
                qntSell: healthSummary.qntSell,
            },
            {
                name: 'Análise fundamentalista',
                qntBuy: funSummary.qntBuy,
                qntSell: funSummary.qntSell,
            },
            {
                name: 'Análise técnica',
                qntBuy: techSummary.qntBuy,
                qntSell: techSummary.qntSell,
            },
        ];
    }
    static getGeneralIndication(qntBuy, qntSell) {
        if (qntBuy > qntSell + 2) {
            return {
                title: 'compra.',
                color: '#66bb6a',
            };
        }
        else if (qntSell > qntBuy + 2) {
            return {
                title: 'venda.',
                color: '#ef5350',
            };
        }
        else {
            return {
                title: 'espera por melhores oportunidades de entrada.',
                color: '#fdd835',
            };
        }
    }
    static techIndicationToDisplayable(indication) {
        switch (indication) {
            case technical_indicator_enum_1.eTechnicalIndicator.NEUTRAL:
                return {
                    name: 'Imparcial',
                    color: '#424242',
                    backgroundColor: null,
                    progressBar: {
                        variant: 'warning',
                        percent: 50,
                    },
                };
            case technical_indicator_enum_1.eTechnicalIndicator.BUY:
                return {
                    name: 'Compra',
                    color: '#43a047',
                    backgroundColor: null,
                    progressBar: {
                        variant: 'success',
                        percent: 70,
                    },
                };
            case technical_indicator_enum_1.eTechnicalIndicator.SELL:
                return {
                    name: 'Venda',
                    color: '#ef5350',
                    backgroundColor: null,
                    progressBar: {
                        variant: 'danger',
                        percent: 30,
                    },
                };
            case technical_indicator_enum_1.eTechnicalIndicator.STRONG_BUY:
                return {
                    name: 'Forte compra',
                    color: '#2e7d32',
                    backgroundColor: '#e8f5e9',
                    progressBar: {
                        variant: 'success',
                        percent: 100,
                    },
                };
            case technical_indicator_enum_1.eTechnicalIndicator.STRONG_SELL:
                return {
                    name: 'Forte venda',
                    color: '#d32f2f',
                    backgroundColor: '#ffebee',
                    progressBar: {
                        variant: 'danger',
                        percent: 10,
                    },
                };
            case technical_indicator_enum_1.eTechnicalIndicator.LESS_VOLATILITY:
            case technical_indicator_enum_1.eTechnicalIndicator.MORE_VOLATILITY:
                return {
                    name: 'Alerta leve',
                    color: '#fdd835',
                    backgroundColor: '#fffde7',
                    progressBar: {
                        variant: 'warning',
                        percent: 40,
                    },
                };
            default:
                return {
                    name: 'Indefinido',
                    color: '#424242',
                    backgroundColor: null,
                    progressBar: {
                        variant: 'warning',
                        percent: 0,
                    },
                };
        }
    }
    static emptySummaryPoints() {
        return {
            qntBuy: 0,
            qntSell: 0,
        };
    }
    static clearSimilarImpressions(configs, impressions) {
        configs.forEach((config) => {
            const { similars, keepOnly } = config;
            const qntSimilarImpressions = impressions.filter((impression) => similars.includes(impression.reportableIdentification)).length;
            if (qntSimilarImpressions >= 2) {
                const keepOnlyImpression = impressions.find((impression) => impression.reportableIdentification === keepOnly);
                impressions = impressions.filter((impression) => !similars.includes(impression.reportableIdentification));
                impressions = [...impressions, keepOnlyImpression];
            }
        });
        return impressions;
    }
}
exports.GeneralUtils = GeneralUtils;
//# sourceMappingURL=general.utils.js.map